import Lara from '@primeuix/themes/lara'
import { definePreset } from '@primeuix/themes'
import { PRIMARY_RAMP, TOKENS } from './shared/design-tokens'

// This is the base theme for primeNg. We use the Lara theme and set the primary color to the
// brand blue. This preset sits *under* the SCSS layer and colors PrimeNG internals that no
// stylesheet reaches, so it has to track the palette in _style-vars.scss and styles.scss.
export const ArpioPreset = definePreset(Lara, {
  primitive: {
    medium: {
      color: TOKENS.mediumColor,
    },
    light: {
      color: TOKENS.lightColor,
    },
  },
  semantic: {
    primary: PRIMARY_RAMP,
    colorScheme: {
      light: {
        focusRing: {
          shadow: 'none',
        },
      },
    },
  },
  components: {
    datatable: {
      header: {
        borderWidth: '0',
        padding: '0.5rem',
      },
      headerCell: {
        padding: '0.2rem 0.5rem',
      },
      bodyCell: {
        borderColor: '{medium.color}',
        padding: '0.5rem',
      },
      loadingIcon: {
        size: null, // fix animation when the spinner is smaller than the default icon size
      },
      colorScheme: {
        light: {
          header: {
            background: '{light.color}',
          },
        },
      },
    },
  },
})
